import {months} from '@app/components/LocalCommon/Constants/Months';
import {MemorialsRes} from '@app/objects/PetMemorial';

export const dateConvert = (memorial: MemorialsRes) => {
	return convertAllDates(memorial.birthday, memorial.dateOfPassing, memorial.dateCreated);
};

export const convertAllDates = (birthday: number | null, dateOfPassing: number | null, dateCreated: number) => {
	let dateBirth: string | null = null;
	let datePass: string | null = null;

	if (birthday) {
		const date_1 = new Date(birthday);
		dateBirth = `${date_1.getUTCMonth() + 1}/${date_1.getUTCDate()}/${date_1.getUTCFullYear()}`;
	}

	if (dateOfPassing) {
		const date_2 = new Date(dateOfPassing);
		datePass = `${date_2.getUTCMonth() + 1}/${date_2.getUTCDate()}/${date_2.getUTCFullYear()}`;
	}

	const date_3 = new Date(dateCreated);
	const datePost = {
		month: months[date_3.getMonth()],
		day: date_3.getDate(),
		year: date_3.getFullYear(),
	};
	return {dateBirth, datePass, datePost};
};